/**
 * Marketplace product media helpers — YouTube watch/share links in the **gallery** only.
 * Aligned with backend LearnManager-style URL patterns (watch, youtu.be, embed, shorts).
 */

/**
 * @param {string} url
 * @returns {string|null} 11-character YouTube video id or null
 */
export function parseYoutubeVideoId(url) {
  if (!url || typeof url !== "string") return null;
  const cleanUrl = url.trim();
  const patterns = [
    /[?&]v=([^"&?/\s]{11})(?:[&\s#]|$)/,
    /youtu\.be\/([^"&?/\s]{11})(?:[?&#]|$)/,
    /youtube\.com\/embed\/([^"&?/\s]{11})(?:[?&#]|$)/,
    /youtube\.com\/shorts\/([^"&?/\s]{11})(?:[?&#]|$)/,
    /youtube\.com\/live\/([^"&?/\s]{11})(?:[?&#]|$)/,
  ];
  for (const p of patterns) {
    const m = cleanUrl.match(p);
    if (m?.[1]) return m[1];
  }
  const loose = cleanUrl.match(/youtube\.com\/[^?]*[?&]v=([^"&?/\s]{11})/);
  if (loose?.[1]) return loose[1];
  return null;
}

/**
 * @param {string} videoId
 * @returns {string|null}
 */
export function getYoutubeEmbedSrc(videoId) {
  if (!videoId || typeof videoId !== "string") return null;
  const id = videoId.trim();
  if (id.length !== 11) return null;
  return `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1`;
}
